import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import {isLoading} from "Modules/Loading"

const initialState = Immutable.Map({})
	.set('GetEvaluations', new Immutable.Map({evaluaciones: {evaluacion: []}}))
	.set('GetFilters', new Immutable.List([]))
	.set('GetGrantees', new Immutable.Map({donatariaEvaluacion: []}))
	.set('ActiveKey', new Immutable.Map({activeKey: 1}))

/* Types */

export const GET_EVALUATIONS_FILTER = 'GET_EVALUATIONS_FILTER'
export const GET_FILTER_FILTER = 'GET_FILTER_FILTER'
export const GET_GRANTEES_FILTER = 'GET_GRANTEES_FILTER'
export const SET_ACTIVE_KEY = 'SET_ACTIVE_KEY'

/* Reducer */
export default (state = initialState, action) => {
	switch (action.type) {
		case GET_EVALUATIONS_FILTER:
			return state.set('GetEvaluations', new Immutable.Map(action.Obj))
		case GET_FILTER_FILTER:
			return state.set('GetFilters', new Immutable.List(action.Obj))
		case GET_GRANTEES_FILTER:
			return state.set('GetGrantees', new Immutable.Map(action.Obj))
		case SET_ACTIVE_KEY:
			return state.set('ActiveKey', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const getEvaluationsFilterByEvaluation = () => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getEvaluationsFilterByEvaluation',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: GET_EVALUATIONS_FILTER, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getFiltersFilterByEvaluation = () => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getFiltersFilterByEvaluation',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: GET_FILTER_FILTER, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getGranteesFilterByEvaluation = (form) => {

	delete form.item
	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getGranteesFilterByEvaluation',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: GET_GRANTEES_FILTER, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const clearGranteeFilter = () => {
	return (dispatch) => {
		dispatch({ type: GET_GRANTEES_FILTER, Obj: {donatariaEvaluacion: []} })		
	}
}

export const setActiveKey = (activeKey) => {
	return (dispatch) => {
		dispatch({ type: SET_ACTIVE_KEY, Obj: {...activeKey} })		
	}
}



// WEBPACK FOOTER //
// ./src/modules/Filter/FilterByEvaluation.js